import {
  AssignableUserRole,
  assignableUserRoleSchema,
  UserRole,
  userRoleSchema,
} from "@/dashboard/features/userManagement/lib/schema";

/** Hierarchy levels for minRole checks. Netic specials match admin so they can see all surfaces. */
export const USER_ROLE_HIERARCHY: Record<UserRole, number> = {
  non_dashboard_user: 0,
  analytics_viewer: 0,
  member: 1,
  manager: 2,
  admin: 3,
  netic_view: 3,
  netic_ds: 3,
};

export function isUserRole(role: string): role is UserRole {
  return userRoleSchema.safeParse(role).success;
}

export function isAssignableUserRole(role: string): role is AssignableUserRole {
  return assignableUserRoleSchema.safeParse(role).success;
}

export function isUserRoleEqualOrAbove(
  role: UserRole,
  minRole: UserRole,
  isSuperAdmin?: boolean
): boolean {
  // Super admins have admin privileges for all roles
  if (isSuperAdmin) {
    return true;
  }

  return USER_ROLE_HIERARCHY[role] >= USER_ROLE_HIERARCHY[minRole];
}
